<template>
  <td>
         <a v-bind:href="url" target="_blank"><font-awesome-icon icon="map"/></a>
    </td>
</template>
<script>
export default {
  props: {
    field: String,
        dataItem: Object,
        format: String,
        className: String,
        columnIndex: Number,
        columnsCount: Number,
        rowType: String,
        level: Number,
        expanded: Boolean,
        editor: String
  },
  computed: {
    url(){
        return "http://rkg.gov.si/GERK/WebViewer/#query=GERK_SDO:GERK_PID:"+this.dataItem.gerkpid;
     }
   }
  
}

</script>